import { useApolloClient } from '@apollo/client/react';
import { useCallback } from 'react';
import { getCurrentUser } from '@guuru/auth-web';
import { useChat, useCurrentChat } from '@guuru/chat-web';
import events from '@guuru/events-web';
import { BOTS } from '@guuru/expert-common';
import { errorCode, errorType } from '@guuru/graphql-common';
import handleChatStatusChange from '../flow/commands/handleChatStatusChange';

const { useTrackEventOnce } = events;

const { NOT_FOUND, FORBIDDEN } = errorType;

export default () => {
  const { chatId, hasCurrentChat } = useCurrentChat();
  const client = useApolloClient();

  const onChatUpdate = useCallback(
    ({ data: subscriptionData }) => {
      const { chatUpdated = {} } = subscriptionData?.data ?? {};
      handleChatStatusChange({ chatId, ...chatUpdated });
    },
    [chatId],
  );

  const { data: { chat: { expert, relatedTimes } = {} } = {} } = useChat({
    chatId: getCurrentUser() && hasCurrentChat ? chatId : null,
    useSubscriptions: true,
    onChatUpdate,
    onChatDelete: () => {
      window.location.reload();
    },
    onError: (e) => {
      if (errorCode(e) === NOT_FOUND) {
        window.location.reload();
        return;
      }
      if (errorCode(e) === FORBIDDEN) {
        client.close();
        return;
      }
      throw e;
    },
  });

  useTrackEventOnce(() => {
    if (expert && expert.id !== BOTS.bot.externalId) {
      events.expertConnected(relatedTimes?.effectiveResponseTime);
    }
  }, [expert]);
};
